import { useState, useCallback } from 'react'
import { toast } from '@sales-center/components'

import { isAPIError } from '@user/store/services/crud'
import { useIsUnmounted } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import { updateOpportunityStatus } from '../api'
import { IOpportunityStatusUpdate } from '../typings'

export function useUpdateOpportunityStatus() {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const isUnmoutned = useIsUnmounted()

  const onUpdateStatus = useCallback(
    async (input: IOpportunityStatusUpdate) => {
      try {
        setStatus('pending')
        const result = await dispatch(updateOpportunityStatus(input))
        if (isUnmoutned()) return
        if (updateOpportunityStatus.fulfilled.match(result)) {
          setStatus('success')
        } else {
          const { payload } = result

          if (isAPIError(payload)) {
            toast.error(payload.Message)
          }

          setStatus('fail')
        }
      } catch {
        if (isUnmoutned()) return
        setStatus('fail')
      } finally {
        if (isUnmoutned()) return
        setStatus('idle')
      }
    },
    [dispatch, isUnmoutned],
  )

  return { status, onUpdateStatus }
}
